export const ARTICLE_LIST_REQUEST  = 'ARTICLE_LIST_REQUEST';
export const ARTICLE_LIST_SUCCESS  = 'ARTICLE_LIST_SUCCESS';
export const ARTICLE_LIST_FAIL     = 'ARTICLE_LIST_FAIL';